import dynamicIconImports from "lucide-react/dynamicIconImports"
import dynamic from "next/dynamic"
import { useMemo } from "react"

import { IconButton, IconButtonProps } from "./IconButton"
import { LucideIconName } from "../../../Icon"

import type { LucideIcon } from "lucide-react"

export interface DynamicIconButtonProps extends Omit<IconButtonProps, "icon"> {
  name: LucideIconName
}

export function DynamicIconButton({
  name,
  ...otherProps
}: DynamicIconButtonProps) {
  const icon = useMemo(
    () => dynamic(dynamicIconImports[name]) as unknown as LucideIcon,
    [name]
  )
  return <IconButton icon={icon} {...otherProps} />
}
